import { TChildrenPayload } from 'src/components/ConfigurationManagementCentral';

export type TMapSidebarCommunitiesListProps = {
  className?: string;
  style?: React.CSSProperties;
};

export enum EListFilter {
  All = 'ALL',
  MyCommunities = 'MY_COMMUNITIES',
}

export type TListHeaderProps = {
  activeFilter: EListFilter;
  onFilterChange: (value: EListFilter) => void;
  searchQuery: string;
  onSearchQueryChange: (data: string) => void;
  isLoggedIn: boolean;
};

export type TCommunitiesListProps = {
  height: number;
  items: any[];
  removeCommunity: TChildrenPayload['handleCommunityRemove'];
  updatePersonalCommunitiesList: () => void;
};
